module.exports = {
  businessIntelligenceChartTab: 'Biểu đồ BI',
  businessIntelligenceDashboardTab: 'Bảng điều khiển BI',
  chartGroupSettingTab: 'Thiết lập nhóm biểu đồ',
  chartConfigurationManagement: 'Quản lý biểu đồ BI thuê bao',
  common: {
    query: 'Tìm kiếm',
    edit: 'Chỉnh sửa',
    save: 'Lưu',
    cancel: 'Hủy',
    tenantName: 'Tên thuê bao',
    saveSuccess: 'Lưu thành công'
  },
  businessIntelligence: {
    searchKeyword: 'Vui lòng nhập từ khóa tìm kiếm',
    copyChart: 'Sao chép biểu đồ và bảng điều khiển',
    copyAll: 'Sao chép đến tất cả thuê bao',
    all: 'Tất cả',
    copyIdRemind: 'Vui lòng nhập ID đối tượng sao chép',
    copyAllRemind: 'Vui lòng chọn thuê bao cần sao chép đến',
    chartIdPlaceholder: 'Vui lòng nhập ID',
    chart: 'Biểu đồ',
    dashboard: 'Bảng điều khiển',
    type: 'Loại',
    copyTo: 'Sao chép đến một số thuê bao',
    copyChartId: 'ID đối tượng sao chép',
    openBiChart: 'Kích hoạt biểu đồ BI',
    openTenantBiChart: 'Kích hoạt biểu đồ BI thuê bao',
    selectTenant: 'Lựa chọn thuê bao',
    keywords: 'Vui lòng nhập từ khóa',
    note: 'Ghi chú',
    chartNumber: 'Chỉnh sửa số lượng biểu đồ thuê bao',
    tenantId: 'ID thuê bao',
    initializeChartNum: 'Số biểu đồ khả dụng',
    hasBeenUsedChart: 'Số biểu đồ đã sử dụng',
    openingDate: 'Ngày kích hoạt',
    adjustNumber: 'Điều chỉnh số lượng',
    expirationTime: 'Thời gian hết hạn',
    selectTime: 'Chọn thời gian',
    adjust1: 'Tăng',
    adjust2: 'Giảm',
    available: 'Số lượng biểu đồ khả dụng của thuê bao',
    hasBeenUsed: 'Số lượng biểu đồ đã sử dụng của thuê bao',
    noteInformation: 'Thông tin ghi chú',
    saveWarning: 'Vui lòng chọn thuê bao',
    saveSuccess: 'Kích hoạt thành công',
    copySuccess: 'Sao chép thành công',
    editWarning: 'Vui lòng hoàn thiện số lượng điều chỉnh',
    editWarningTime: 'Vui lòng điền thời gian hết hạn',
    editSuccess: 'Lưu thành công',
    adjustQuantity1: 'Số lượng điều chỉnh không thể nhập số âm',
    adjustQuantity2: 'Số lượng giảm điều chỉnh không thể lớn hơn số biểu đồ người dùng'
  },
  businessIntelligenceChart: {
    myChartNum: 'Số biểu đồ của tôi',
    addChart: 'Thêm biểu đồ tùy chỉnh',
    queryChart: 'Truy vấn biểu đồ của tôi',
    standardChart: 'Thư viện mẫu biểu đồ chuẩn BI (Vui lòng chọn biểu đồ cần thiết)',
    queryStandardChart: 'Truy vấn mẫu biểu đồ',
    chartTemplate: 'Mẫu biểu đồ:',
    classification: 'Phân loại:',
    chartName: 'Tên biểu đồ',
    chartGrouping: 'Nhóm biểu đồ',
    chartId: 'Giá trị ID biểu đồ',
    remark: 'Ghi chú',
    editChart: 'Chỉnh sửa biểu đồ người dùng',
    selectAll: 'Tất cả',
    hasChosen: 'Đã chọn',
    notChoose: 'Chưa chọn',
    chartNamePrompt: 'Vui lòng nhập tên biểu đồ',
    chartIdPrompt: 'Vui lòng nhập giá trị ID biểu đồ',
    addSuccess: 'Thêm thành công',
    deleteSuccess: 'Xóa thành công',
    warmPrompt: 'Lưu ý',
    warmPromptStatements: 'Kính gửi quý khách, số lượng biểu đồ sử dụng (${0} cái) đã đạt giới hạn. Nếu cần tăng số lượng biểu đồ có thể sử dụng, vui lòng liên hệ dịch vụ khách hàng trực tuyến WallTech hoặc gọi số 021-65143931 để được tư vấn.',
    confirmButtonText: 'Đã hiểu'
  },
  chartGroupSetting: {
    viewChart: 'Xem biểu đồ',
    newGrouping: 'Tạo nhóm mới',
    delete: 'Xóa',
    order: 'Số thứ tự',
    groupName: 'Tên nhóm',
    groupNameTips: 'Tên nhóm không được trùng lặp',
    remark: 'Ghi chú',
    selectGrouping: 'Chọn biểu đồ để thêm vào nhóm',
    queryChartName: 'Tìm kiếm tên biểu đồ',
    eidtChart: 'Chỉnh sửa biểu đồ',
    currentGrouping: 'Nhóm hiện tại',
    chartDescription: 'Mô tả biểu đồ',
    addGroup: 'Thêm nhóm mới',
    editGroup: 'Chỉnh sửa nhóm',
    rankRemind: 'Vui lòng nhập số thứ tự nhóm',
    groupingNameRemind: 'Vui lòng nhập tên nhóm',
    chartNameRemind: 'Vui lòng nhập tên biểu đồ',
    chartGrouping: 'Vui lòng chọn nhóm biểu đồ',
    deleteSuccess: 'Xóa thành công'
  },
  businessIntelligenceDashboard: {
    addDashboard: 'Thêm bảng điều khiển',
    delete: 'Xóa',
    fullScreen: 'Hiển thị toàn màn hình',
    setFilter: 'Thiết lập tùy chọn lọc',
    preview: 'Xem trước',
    saveLayout: 'Lưu bố cục',
    dragTips: 'Bạn có thể điều chỉnh vị trí và kích thước biểu đồ bằng cách kéo thả.',
    addChart: 'Thêm biểu đồ',
    dashboardType: 'Loại bảng điều khiển',
    customizeDashboard: 'Bảng điều khiển tùy chỉnh',
    biDashboard: 'Bảng điều khiển BI',
    dashboardName: 'Tên bảng điều khiển',
    dashboardId: 'Giá trị ID bảng điều khiển',
    dashboardNamePlaceholder: 'Vui lòng nhập tên bảng điều khiển',
    classification: 'Phân loại bảng điều khiển',
    biDashboardId: 'Giá trị ID bảng điều khiển BI',
    biDashboardIdPlaceholder: 'Vui lòng nhập giá trị ID bảng điều khiển',
    Notes: 'Ghi chú giải thích',
    setAccessRights: 'Thiết lập quyền truy cập',
    selectBranch: 'Chọn chi nhánh',
    selectBranchPlaceholder: 'Vui lòng chọn công ty',
    selectDepartment: 'Chọn phòng ban',
    selectDepartmentPlaceholder: 'Vui lòng chọn phòng ban',
    selectPersonnel: 'Chọn nhân viên',
    selectPersonnelPlaceholder: 'Vui lòng chọn nhân viên',
    setDataPermission: 'Thiết lập quyền dữ liệu',
    whole: 'Xem tất cả dữ liệu',
    company: 'Xem dữ liệu chi nhánh',
    department: 'Xem dữ liệu phòng ban',
    personal: 'Chỉ xem dữ liệu cá nhân',
    rolePermissions: 'Xem dữ liệu theo quyền vai trò',
    chartAddDashboard: 'Chọn biểu đồ để thêm vào bảng điều khiển',
    queryChartName: 'Tìm kiếm tên biểu đồ',
    add: 'Thêm',
    seePreview: '*Vui lòng nhấp vào xem trước để kiểm tra hiệu ứng',
    determine: 'Xác nhận',
    setQueryItem: 'Thiết lập mục truy vấn bảng điều khiển',
    grouping: 'Nhóm',
    businessDashboard: 'Bảng điều khiển nghiệp vụ',
    financialDashboard: 'Bảng điều khiển tài chính',
    deleteConfirm: 'Bạn có muốn xóa bảng điều khiển này không?',
    tips: 'Thông báo',
    saveTips: 'Vui lòng chọn biểu đồ để thêm vào bảng điều khiển',
    saveTips1: 'Tên bảng điều khiển không được trùng lặp',
    prompt1: 'Thiết lập quyền truy cập bảng điều khiển, ví dụ: Chi nhánh Thượng Hải, Phòng vận hành, Trương Tam.',
    prompt2: 'Nếu chỉ thiết lập chi nhánh, tất cả nhân viên thuộc công ty đó đều có thể truy cập.',
    prompt3: 'Quyền dữ liệu có thể giới hạn phạm vi hiển thị dữ liệu cho người dùng hiện tại.',
    prompt4: 'Ví dụ: Chỉ cá nhân, nghĩa là chỉ xem dữ liệu nghiệp vụ của mình.',
    prompt5: 'Có thể liên hệ với dịch vụ khách hàng trực tuyến WallTech hoặc số vận hành 021-65143931 để biết thêm chi tiết!',
    prompt6: 'Kính gửi quý khách thuê, nếu cần tìm hiểu và sử dụng thêm các ứng dụng BI, vui lòng liên hệ dịch vụ khách hàng trực tuyến WallTech hoặc gọi số 021-65143931 để được tư vấn.'
  }
}
